import store from '../../../vue-plugins/vuex/index'

const stepIcon = require('assets/images/map/ico-parada.png')
const userIcon = require('assets/images/map/ico-group-user.png')
const defaultLogoUrl = require('assets/images/transport-logo-default.svg')
const bicycleIcon = require('assets/images/map/Valenbisi.svg')
const bici = require('assets/images/map/bici.svg')
const taxi = require('assets/images/map/taxi.svg')
const walkingIcon = require('assets/images/map/walk.svg')
const car = require('assets/images/map/coche.svg')
const valenbiciMap = require('assets/images/map/valenbici-map.svg')
const destinyMarkerIcon = require('assets/images/icon-destiny-details.svg')
const motorcycle = require('assets/images/map/motorcycle.svg')

const BaseMarker = L.Icon.extend({
  options: {
    iconAnchor: [55, 55]
  }
})

const createIconMarker = (iconName, rootClassNames) => L.divIcon({
  html: `<i class="ns-icon-${iconName}" />`,
  className: `step-marker ${rootClassNames}`
})

const userPositionMarker = new BaseMarker({
  className: 'leaflet-userPosition',
  iconUrl: userIcon
})

const destinyMarker = new BaseMarker({
  iconUrl: destinyMarkerIcon,
  iconSize: [30, 30], // Ajusta el tamaño del icono
  iconAnchor: [15, 15], // Ajusta el punto de anclaje del icono
  popupAnchor: [0, -15]
})

const stepMarker = new BaseMarker({
  iconUrl: stepIcon,
  iconAnchor: [8, 8],
  popupAnchor: [0, -8]
})

const iconMapping = {
  WALK: walkingIcon,
  BICYCLE: step => step.rentedBike ? valenbiciMap : bici,
  TAXI: taxi,
  CAR: car,
  MOTORCYCLE: motorcycle
};

const getStepMarkerIconOperator = step => {
  const iconUrl = typeof iconMapping[step.mode] === 'function' ? iconMapping[step.mode](step) : iconMapping[step.mode];

  if (iconUrl) {
    return new BaseMarker({
      iconUrl,
      iconAnchor: [8, 8],
      popupAnchor: [0, -8]
    });
  }

  const operators = store.getters.operators;
  const logo = operators?.filter(item => item.agency_id === step.agencyId);
  const defaultIconUrl = logo?.[0]?.logo_url || stepIcon;

  return new BaseMarker({
    iconUrl: defaultIconUrl,
    iconAnchor: [8, 8],
    popupAnchor: [0, -8]
  });
};

const getOperatorStepMarker = step => {
  const operators = store.getters.operators
  const logo = operators?.filter(item => item.agency_id === step.agencyId)
  return logo?.[0]?.logo_url || logo?.[0]?.logo_url || defaultLogoUrl
}

const getBicycleIcon = bicycleIcon

export {
  userPositionMarker,
  destinyMarker,
  stepMarker,
  getOperatorStepMarker,
  getBicycleIcon,
  getStepMarkerIconOperator
}